import { put } from 'aws-amplify/api';
import { fetchAuthSession, signOut } from 'aws-amplify/auth';
import { useMutation } from 'react-query';
import type { QueryKeys } from '@/constants/query-key';
import { queryKeys } from '@/constants/query-key';
import { handleMaintenance } from '@/modules/utils/sign-out-utils';
import * as paths from '@/routes/paths';
import { removeSettingState } from '@/state/callbackHelpers';

export const apiPut = async (apiName: string, path: string, options?: object) => {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const { response } = put({
      apiName,
      path,
      options: {
        ...options,
        headers: {
          Authorization: authToken as string,
        },
      },
    });

    return await response;
  } catch (error) {
    let statusCode = 0;

    if (error && typeof error === 'object' && 'response' in error) {
      const err = error as { response: { statusCode: number; body: string } };

      if (err.response?.statusCode) {
        statusCode = err.response.statusCode;
      }
      handleMaintenance(statusCode, err.response.body);
    }

    // // lambdaのタイムアウト、lambdaのメモリ超過
    if (statusCode === 502) {
      throw new Error('システムエラーが発生しました。時間を置いてリクエストしてください。');
    }

    if (statusCode === 403) {
      signOut()
        .then(() => {
          removeSettingState();
          window.location.replace(`/#${paths.login}`);
        })
        .catch(() => {});
    }

    throw new Error(error instanceof Error ? `${error.message} (${error?.name})` : '');
  }
};

const apiPut1 = async <T>(apiName: string, path: string, options?: object) => {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();

  try {
    const { response } = put({
      apiName,
      path,
      options: {
        ...options,
        headers: {
          Authorization: authToken as string,
        },
      },
    });
    if ((await response).statusCode === 204) {
      return await Promise.resolve({} as T);
    }

    return await ((await response).body.json() as Promise<T>);
  } catch (error) {
    let statusCode = 0;

    if (error && typeof error === 'object' && 'response' in error) {
      const err = error as { response: { statusCode: number; body: string } };

      if (err.response?.statusCode) {
        statusCode = err.response.statusCode;
      }
      handleMaintenance(statusCode, err.response.body);
    }

    // // lambdaのタイムアウト、lambdaのメモリ超過
    if (statusCode === 502) {
      throw new Error('システムエラーが発生しました。時間を置いてリクエストしてください。');
    }

    if (statusCode === 403) {
      signOut()
        .then(() => {
          removeSettingState();
          window.location.replace(`/#${paths.login}`);
        })
        .catch(() => {});
    }

    throw new Error(error instanceof Error ? `${error.message} (${error?.name})` : '');
  }
};

export const useUpdate = <T>(key: QueryKeys, apiName: string, path: string, options?: object) => {
  const res = useMutation<T, Error, Partial<T>>({
    mutationKey: queryKeys[key],
    mutationFn: async (postData) => apiPut1<T>(apiName, path, { ...options, body: postData }),
  });

  return res;
};
